export class TnxMetrics {
  failed: number;
  aboutToExpire: number;
  canceled: number;
  updated: number;

  public static fromDto(p: any) {
    if (!p) {
      return null;
    }

    const metrics = new TnxMetrics();

    metrics.failed = p.loads_in_failure;
    metrics.aboutToExpire = p.loads_about_to_expire;
    metrics.canceled = p.loads_canceled;
    metrics.updated = p.loads_updated;

    return metrics;
  }
}
